<template>
  <div class="ProjectEdit__part">
    <violet-bar>Surface / Coût</violet-bar>
    <help-message>
      <h3 slot="title">Surface, coût, données numériques</h3>
      <p>
        Toutes les données numériques (chiffres, nombres) doivent être saisis
        <strong>sans formatage</strong>. <br />
        Un million se saisit donc "1000000", huit mille mètres carrés "8000".<br />Le
        formatage interviendra automatiquement au moment de la mise en page sur
        un support.
      </p>
    </help-message>
    <div class="squarebox">
      <div class="columns is-multiline">
        <div class="column is-one-quarter">
          <vertical-field>
            <label for="" class="label" slot="label">Budget en €</label>
            <input type="text" class="input" v-model="project.cost" />
          </vertical-field>
        </div>
      </div>
      <label for="" class="label" slot="label">Surfaces en m²</label>
      <project-edit-surfaces
        :item="item"
        @update="project = $event"
      ></project-edit-surfaces>
    </div>
  </div>
</template>
<script>
import VerticalField from "../../../components/Form/VerticalField";
import VioletBar from "../VioletBar";
import HelpMessage from "../../../components/Form/HelpMessage";
import ProjectEditSurfaces from "./ProjectEditSurfaces";

export default {
  name: "ProjectEdit-SurfaceCost",
  components: { ProjectEditSurfaces, HelpMessage, VerticalField, VioletBar },
  props: {
    item: {}
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  }
};
</script>
